import type { MatchPropertyMatchType } from '../types';
import { ctw } from '@/common';

const DOT_COLORS: Record<MatchPropertyMatchType, string> = {
  exact: 'bg-red-500',
  partial: 'bg-orange-400',
  none: 'bg-slate-300',
};

/** Colored indicator for a property match type (exact / partial / none). */
export const MatchPropertyDot = ({
  matchType,
  className,
}: {
  matchType: MatchPropertyMatchType;
  className?: string;
}) => (
  <span
    className={ctw('inline-block h-2 w-2 shrink-0 rounded-full', DOT_COLORS[matchType], className)}
    aria-hidden
  />
);
